<template>
  <ModalOverlay
    v-model="showModal"
    :video-modal="true"
    :swiper-data="[youtubeVideoId]"
    background-class="b-pop-up--video b-pop-up__holder"
    header-background-class="b-pop-up__header">
    <template #header>
      <div class="b-pop-up__header__title">{{ title }}</div>
    </template>
  </ModalOverlay>
</template>

<script>
// import { getHTMLData } from '../../lib/lib'
import ModalOverlay from '../components/ModalOverlay.vue'

export default {
  components: {
    ModalOverlay,
  },
  data() {
    return {
      showModal: false,
      youtubeVideoId: '',
      title: 'Trailer',
    }
  },
  mounted() {
    window.addEventListener('trailer-clicked', (e) => {
      const { link } = e.detail
      const vid = jQuery(link).data('video-id')
      const title = jQuery(link).data('video-title')
      this.youtubeVideoId = vid ? vid : ''
      this.title = title ? title : 'Trailer'
      this.activateModal()
    })
  },
  methods: {
    activateModal() {
      console.log('activateModal()')
      this.showModal = true
    },
  },
}
</script>
